function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "e23e072f-2fc2-4c9c-8d4a-6c10d8b1023a",
  "data-name": "Fill-1",
  d: "M17.88,10.84,15,13.73l-2.91-2.91a.92.92,0,0,0-1.33,0l-.07.09a.92.92,0,0,0,.1,1.23l2.88,2.89L10.78,18a.93.93,0,0,0,0,1.33,1,1,0,0,0,.65.26h.12a.93.93,0,0,0,.53-.27L15,16.36l2.91,2.91a.94.94,0,0,0,.66.28.9.9,0,0,0,.65-.28l.08-.09a.91.91,0,0,0-.09-1.24l-2.89-2.89,2.89-2.91a.92.92,0,0,0,0-1.33A.9.9,0,0,0,17.88,10.84Z"
});

var SvgIconDelete = function SvgIconDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return _ref2;
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-delete.9ca2d5d0.svg";
export { ForwardRef as ReactComponent };